
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"#f4be5e"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 474.718C135.4 474.718 37.282 376.6 37.282 256S135.4 37.282 256 37.282 474.718 135.4 474.718 256 376.6 474.718 256 474.718z"}}),_c('path',{attrs:{"d":"M79.392 406.842L406.23 80.003l26.357 26.357-326.84 326.84z"}})])
          )
        }
      }
    